//media modal
export const MEDIA_MODAL_TYPES = {
    MEDIA_MAIN: 'MEDIA_MAIN',
    MEDIA_ARRAY: 'MEDIA_ARRAY',
};

export const MEDIA_TYPES = {
    FILE: 'FILE',
    FOLDER: 'FOLDER',
};

export const UPLOAD_TYPES = {
    SELF: 'SELF',
    URL: 'URL',
};

const STATUS_COLORS = {
    NEW: '#FF9112',
    CANCELLED: '#828B99',
    APPROVED: '#13C712',
    REJECTED: '#FF1212',
};
export const REVIEW_STATUS_TYPES = {
    INITIAL: {
        key: 'INITIAL',
        title: 'Նոր',
        color: STATUS_COLORS.NEW
    },
    APPROVED: {
        key: 'APPROVED',
        title: 'Հաստատված',
        color: STATUS_COLORS.APPROVED
    },
    REJECTED: {
        key: 'REJECTED',
        title: 'Մերժված',
        color: STATUS_COLORS.REJECTED
    },
};


export const STATUS_LIST = {
    NEW: {
        title: "Հաստատել",
        key: '5ee8dd7c4ac0e93f4336fcda',
        color: STATUS_COLORS.NEW,
    },
    CANCELLED: {
        title: 'Չեղարկված',
        key: '5ee8dda24ac0e93f4336fcdd',
        color: STATUS_COLORS.CANCELLED,
    },
    APPROVED: {
        title: 'Հաստատված',
        key: '5ee8dd984ac0e93f4336fcdb',
        color: STATUS_COLORS.APPROVED,
    },
    REJECTED: {
        title: 'Մերժված',
        key: '5ee8dda24ac0e93f4336fcdc',
        color: STATUS_COLORS.REJECTED,
    },
};
export const MEASUREMENT_TYPES = {
    LITER: 'Լ',
    KILOGRAM: 'Կգ',
    PIECES: 'Հատ',
    BOX: 'Արկղ',
};

export const PROMO_CODE_STATUS = {
    USED: "Օգտագործված",
    OPEN: "Չօգտագործված"
};


export const SLIDER_RESOURCE_TYPES = {
    PRODUCT: {
        title: 'Ապրանք',
        key: 'PRODUCT',
    },
    BLOG: {
        title: 'Բլոգ',
        key: 'BLOG',
    },
    BRAND :{
        title: 'Բրենդ',
        key: 'BRAND ',
    },
    /*CUSTOM_PAGE:{
        title: 'Դինամիկ Էջ',
        key: 'CUSTOM_PAGE',
    },*/
};

export const ADVERTISING_RESOURCE_TYPES = {
    PRODUCT: {
        title: 'Ապրանք',
        key: 'PRODUCT',
    },
    URL: {
        title: 'Հղում',
        key: 'URL',
    },
    CUSTOM_PAGE:{
        title: 'Դինամիկ Էջ',
        key: 'CUSTOM_PAGE',
    },
};

export const HISTORY_TYPES = {
    BONUS_FROM_ORDER: 'BONUS_FROM_ORDER',
    ORDER_VIA_BONUS_CARD: 'ORDER_VIA_BONUS_CARD'
};

export const DEFAULT_IMAGE_ID = '5db99765e2019423d6e0df80';

